import React from 'react';
import {
  ColorPicker,
  ColorPickerProps,
  FlatColorPickerProps,
  FlatColorPickerChangeEvent
} from '@progress/kendo-react-inputs';

type FlatColorPickerSettingsWithoutPreview = Omit<
  FlatColorPickerProps,
  'onPreviewChange'
>;

export type KendoReactColorPickerProps = Omit<
  ColorPickerProps,
  'flatColorPickerSettings'
> & {
  flatColorPickerSettings?: FlatColorPickerSettingsWithoutPreview & {
    onPreviewChange?: (hexColor: string) => void;
  };
};

const KendoReactColorPicker = ({
  flatColorPickerSettings,
  ...props
}: KendoReactColorPickerProps) => {
  const rgbToHex = (rgb: string): string => {
    const match = rgb.match(/\d+/g);
    if (!match) return '000000';
    return match
      .slice(0, 3)
      .map((x) => parseInt(x).toString(16).padStart(2, '0'))
      .join('');
  };

  const handlePreviewChange = (event: FlatColorPickerChangeEvent) => {
    if (flatColorPickerSettings?.onPreviewChange) {
      const hexColor = rgbToHex(event.value);
      flatColorPickerSettings.onPreviewChange(hexColor);
    }
  };

  const modifiedFlatSettings = {
    ...flatColorPickerSettings,
    onPreviewChange: handlePreviewChange
  };

  return (
    <div className="kendo-react-color-picker">
      <link
        href="https://kendo.cdn.telerik.com/themes/7.0.1/material/material-main.css"
        rel="stylesheet"
        type="text/css"
      />
      <ColorPicker {...props} flatColorPickerSettings={modifiedFlatSettings} />
    </div>
  );
};

export default KendoReactColorPicker;

export type { ColorPickerChangeEvent } from '@progress/kendo-react-inputs';
